module.exports = __webpack_public_path__ + "static/media/Units.312273e0.svg";